export const JOIN_ROOM = 'JOIN_ROOM';
export const DATA_COLLECT_ROOM = 'DATA_COLLECT_ROOM';
export const DATA_COLLECT_ROOM_MESSAGE = 'DATA_COLLECT_ROOM_MESSAGE';
